import pino from 'pino';
import { assertCanHandle } from '@lucidlink/tscore';
export class ObservableLogger {
    logger;
    callbacks = new Set();
    constructor(optionsOrStream) {
        this.logger = pino({
            ...optionsOrStream,
            timestamp: pino.stdTimeFunctions.isoTime,
            browser: {
                asObject: true,
                transmit: {
                    send: (_level, event) => this.invokeCallbacks(event),
                },
            },
        });
    }
    getLogger() {
        return this.logger;
    }
    getSubscriptions() {
        return this.callbacks;
    }
    subscribe(callback) {
        this.callbacks.add(callback);
    }
    unsubscribe(callback) {
        return this.callbacks.delete(callback);
    }
    clearSubscriptions() {
        this.callbacks.clear();
    }
    invokeCallbacks(event) {
        for (const callback of this.callbacks) {
            try {
                callback(event);
            }
            catch (error) {
                assertCanHandle(error, (error) => error instanceof Error);
            }
        }
    }
}
export const ObservableRootLogger = new ObservableLogger();
